<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="10"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    :multi-sort="multiSort"
  >
    <template v-slot:header.form_emails.is_additional_notify="{ header }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span>{{ header.text }}</span>
          <v-icon class="pl-1" small v-on="on">
            mdi-information-variant-circle-outline
          </v-icon>
        </template>
        <span>{{ $t('FORMS.DEF_SEND') }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.form_emails.is_additional_notify="{ item }">
      <v-checkbox
        class="d-inline-block"
        :input-value="(item.form_emails || {}).is_additional_notify || false"
        readonly
      />
    </template>

    <template v-slot:item.form_emails.emails="{ item }">
      <div v-if="getEmails(item).length < 4">
        <v-chip v-for="email in getEmails(item)" :key="email" class="mr-1">
          {{ email }}
        </v-chip>
      </div>

      <v-tooltip v-else top>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-chip
              v-for="email in getEmails(item).slice(0, 3)"
              :key="email"
              class="mr-1"
            >
              {{ email }}
            </v-chip>
            <span>... +{{ getEmails(item).length - 3 }} </span>
          </span>
        </template>
        <span style="max-width: 500px; float: left; word-wrap: break-word;">
          <v-chip v-for="email in getEmails(item)" :key="email" class="ma-1">
            {{ email }}
          </v-chip></span
        >
      </v-tooltip>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('edit', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-pencil</v-icon>
            {{ $t('ITEM.EDIT') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'AppsList',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    sortBy: {
      type: [String, Array],
      default: 'application'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({}),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'application'
        },
        {
          text: this.$t('TILES.ITEM_GROUP'),
          value: 'tile_group'
        },
        {
          text: this.$t('FORMS.NOTIFY_SENDING'),
          value: 'form_emails.is_additional_notify',
          width: '210px',
          align: 'center'
        },
        {
          text: this.$t('ITEM.EMAILS'),
          value: 'form_emails.emails',
          align: 'center'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  methods: {
    getEmails(item) {
      return (item.form_emails || {}).emails || [];
    }
  }
};
</script>

<style scoped></style>
